import { ReactNode } from "react";

export function PlainSection(props: {id: string, index: number, active: boolean, children: ReactNode | Array<ReactNode>}){
    return <div 
      aria-labelledby={'title-'+props.id}
      inert={!props.active} 
      className={
        (props.index == 0 ? "top_section" : "") + 
        (" section section-" + props.id) + 
        (props.active ? "" : " section--hidden")
      } 
      key={props.id}
    >
      {props.children}
    </div>;
}